import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './CheckboxEditor.module.scss';

export default class CheckboxEditor extends Component {
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.bool,
        disabled: PropTypes.bool,
        onValueChanged: PropTypes.func,
    };

    static defaultProps = {
        label: 'I am CheckboxEditor',
        value: false,
        onValueChanged: () => {},
    };

    onClick = () => {
        const { value, disabled, onValueChanged } = this.props;
        if (disabled) {
            return;
        }
        onValueChanged(!value);
    };

    render() {
        const { value, label, disabled } = this.props;
        const checkedClass = value ? s.checked : s.unchecked;

        return (
            <div className={classNames(s.checkboxEditor, checkedClass, { [s.disabled]: disabled })}>
                <div className={s.outerBox} onClick={this.onClick}>
                    <div className={s.innerBox} />
                    <div className={classNames(s.checkmark, 'icon-tick')} />
                </div>
                <span className={s.label}>{label}</span>
            </div>
        );
    }
}
